import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Fab, Zoom } from '@mui/material';
import { useLocation } from '@tanstack/react-router';
import React, { useEffect, useRef, useState } from 'react';

import SocialFeedRailNav from './SocialFeedRailNav';
import SocialFeedSidebar from './SocialFeedSidebar';
import SocialFeedTopNav from './SocialFeedTopNav';

type TProps = {
  children: React.ReactNode;
};

const SocialFeedLayout = ({ children }: TProps) => {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLDivElement>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // TODO
  useEffect(() => {
    document.documentElement.style.fontSize = '16px';
    return () => {
      document.documentElement.style.fontSize = '';
    };
  }, []);

  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;
    const handleScroll = () => setShowScrollTop(el.scrollTop > 100);
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollTop = () => {
    mainRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const shouldShowSidebar = (): boolean => pathname == '/updates';

  return (
    <div className='flex h-screen flex-col overflow-hidden'>
      <SocialFeedTopNav />
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <SocialFeedRailNav />
        <Box
          ref={mainRef}
          component='main'
          sx={{
            flex: 1,
            borderTopLeftRadius: '16px',
            overflow: 'hidden',
            overflowY: 'auto',
            bgcolor: 'grey.50',
            borderLeft: '1px solid',
            borderTop: '1px solid',
            borderColor: 'divider',
            isolation: 'isolate',
            position: 'relative',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(218, 101, 19, 0.1)' },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#da6513',
              borderRadius: '3px',
              '&:hover': { backgroundColor: '#c55a11' }
            }
          }}
        >
          {children}
          <Zoom in={showScrollTop}>
            <Fab
              size='small'
              onClick={handleScrollTop}
              sx={{
                position: 'fixed',
                bottom: 32,
                right: 32,
                opacity: 0.6,
                bgcolor: '#DA6513',
                color: '#FFFFFF',
                '&:hover': { bgcolor: '#DA6513', opacity: 1 }
              }}
            >
              <KeyboardArrowUpIcon />
            </Fab>
          </Zoom>
        </Box>
        {shouldShowSidebar() && <SocialFeedSidebar />}
      </Box>
    </div>
  );
};

export default SocialFeedLayout;
